import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function exchangeToken(key) {
	return fetch(
		`${ENDPOINT_URL}/token/exchange`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				key: key,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
